export const outputs = {
	outputs: {
		readMore: "Read More",
		externalNotice: "This article is published on an external site",
		readArticle: "Read Article",
		backToOutputs: "Back to Outputs",
	},

	talks: {
		viewTalk: "View Talk",
	},
} as const;
